// extracted by mini-css-extract-plugin
export var standaloneTable = "_x-0";
export var standaloneTableWithBodyFill = "_x-1";
export var withExtraHeader = "_x-2";